(() => {
  if (window.PerfumePalaceMotion) return;

  const root = document.documentElement;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const readTime = (property, fallback) => {
    const value = window.getComputedStyle(root).getPropertyValue(property).trim();
    if (!value) return fallback;
    if (value.endsWith('ms')) return Number.parseFloat(value);
    if (value.endsWith('s')) return Number.parseFloat(value) * 1000;
    return fallback;
  };

  const tokens = Object.freeze({
    get fastDuration() {
      return readTime('--pp-motion-fast', 160);
    },
    get standardDuration() {
      return readTime('--pp-motion-standard', 220);
    },
    get sectionDuration() {
      return readTime('--pp-motion-section', 320);
    },
    get carouselDuration() {
      return readTime('--pp-motion-carousel', 320);
    },
    get autoAdvanceDelay() {
      return readTime('--pp-motion-auto-advance', 4200);
    }
  });

  const easing = Object.freeze({
    outCubic: (progress) => 1 - Math.pow(1 - progress, 3)
  });

  const frames = Object.freeze({
    request: (callback) => window.requestAnimationFrame(callback),
    cancel: (frame) => window.cancelAnimationFrame(frame)
  });

  const timers = Object.freeze({
    set: (callback, delay) => window.setTimeout(callback, delay),
    clear: (timer) => window.clearTimeout(timer)
  });

  window.PerfumePalaceMotion = Object.freeze({
    reducedMotion,
    tokens,
    easing,
    frames,
    timers,
    now: () => window.performance.now(),
    directionSign: (element) => (window.getComputedStyle(element).direction === 'rtl' ? -1 : 1),
    canAnimate: () => !reducedMotion.matches
  });
  root.dataset.ppMotionSystem = 'ready';
})();
